import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'csrftoken';      // Django defaults
axios.defaults.xsrfHeaderName = 'X-CSRFToken';    // Django expects this
axios.defaults.timeout = parseInt(process.env.VUE_APP_AXIOS_TIMEOUT, 10) || 300000;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export async function initCsrf() {
  try {
    await axios.get('/api/get-csrf-token'); // your Django URL (no trailing slash)
    const token = getCookie('csrftoken');
    if (token) {
      axios.defaults.headers.post['X-CSRFToken'] = token;
      axios.defaults.headers.put['X-CSRFToken'] = token;
      axios.defaults.headers.patch['X-CSRFToken'] = token;
      axios.defaults.headers.delete['X-CSRFToken'] = token;
    }
  } catch (e) {
    console.error('❌ Failed to set CSRF cookie:', e);
  }
}

export default axios;
